(function () {
    const tileListingWrap = document.querySelector('.tiles-listing-wrap');
    const tileListingPageMainWrap = document.querySelector('.tiles-search-info-wrap:not(.resources-listing-search-info-wrap)');
    const totalTiles = document.querySelector('.total-tiles');
    //Check for all products class in pagination
    const checkTileListing = document.querySelector('.pagination.tile-listing');
    // Accordion Click Event
    const accordionAnchor = document.querySelectorAll(".tiles-search-info-wrap .accordion-body ul li a");
    const filterCross = document.querySelectorAll("span.filter-close:not(.resources)");
    const sortTiles = document.querySelector('.tiles-search-info-wrap .tiles-sort');
    const searchField = document.getElementById("search-field");
    const loader = document.querySelector('#loading');
    let dataTax = '';
    let dataSlug = '';
    let tilesCatObj = {};
    let filtertilesObjects = '';
    if(tileListingPageMainWrap){
    for (let i = 0; i < accordionAnchor.length; i++) {
        accordionAnchor[i].addEventListener("click", function () {
            let scrollPosition = tileListingWrap.offsetTop;
            if(window.innerWidth < 992){
                window.scroll({
                    top: scrollPosition - 100,
                    behavior: 'smooth'
                });
            }else{
                window.scroll({
                    top: scrollPosition - 500,
                    behavior: 'smooth'
                });
            }   
            dataTax = accordionAnchor[i].getAttribute('data-tax');
            dataSlug = accordionAnchor[i].getAttribute('data-slug');
            // Check if the dataTax key already exists in tilesCatObj
            if (tilesCatObj.hasOwnProperty(dataTax)) {
                // If yes, check if dataSlug already exists in the array
                if (!tilesCatObj[dataTax].includes(dataSlug)) {
                    // If not, append dataSlug to the array
                    tilesCatObj[dataTax].push(dataSlug);
                }
            } else {
                // If not, create a new key with an array containing dataSlug
                tilesCatObj[dataTax] = [dataSlug];
            }
            filtertilesObjects = JSON.stringify(tilesCatObj);
            let searchInput = searchField.value != '' ? searchField.value : '';
            if(!accordionAnchor[i].classList.contains('active')){
                filterTiles(1,'',searchInput,filtertilesObjects);
            }
            accordionAnchor[i].classList.add('active');
        });
    }

    if(checkTileListing){
        pagination();
    }

    //clear anchor filter
    filterCross.forEach(function(item){
        item.addEventListener('click',function(){
            item.previousElementSibling.classList.remove('active');
            dataTax = item.previousElementSibling.getAttribute('data-tax');
            dataSlug = item.previousElementSibling.getAttribute('data-slug');
            let searchValue = searchField.value;
            if (tilesCatObj.hasOwnProperty(dataTax)) {
                let index = tilesCatObj[dataTax].indexOf(dataSlug);
                if (index !== -1) {
                    tilesCatObj[dataTax].splice(index, 1);
                    if (tilesCatObj[dataTax].length === 0) {
                        delete tilesCatObj[dataTax];
                    }
                }
            }
            let filtertilesObjects = JSON.stringify(tilesCatObj);
            filtertilesObjects = filtertilesObjects != '' ? filtertilesObjects : '';
            filterTiles(1,'',searchValue,filtertilesObjects);
            let scrollPosition = tileListingWrap.offsetTop;
            if(window.innerWidth < 992){
                window.scroll({
                    top: scrollPosition - 100,
                    behavior: 'smooth'
                });
            }else{
                window.scroll({
                    top: scrollPosition - 500,
                    behavior: 'smooth'
                });
            }
        })
    })

    // Clear filter
    const clearFilter = document.querySelector(".reset-tiles-filters");

    if (clearFilter) {
        clearFilter.addEventListener("click", function () {
            // Iterate through each accordion links and remove the active class
            if(searchField){
                searchField.value = '';
            }
            this.classList.add('spinning');
            accordionAnchor.forEach(function (item) {
                item.classList.remove('active');
            });
            filterTiles();
        });
    }

    // Pagination function
    function pagination() {
        let pagination = document.querySelectorAll(".pagination .page-link");
        let searchValue = '';
        if(searchField){
            searchValue = searchField.value != '' ? searchField.value : '';
        }
        for (let i = 0; i < pagination.length; i++) {
        pagination[i].addEventListener("click", function (e) {
            e.preventDefault();
            let pageNo = pagination[i].getAttribute("data-pageno");
            let activeAnchorSelector = document.querySelectorAll('.tiles-search-info-wrap .accordion-body ul li a.active');
            let sortTilesType = '';
            if(sortTiles){
                if(sortTiles.classList.contains('active')){
                    sortTilesType = sortTiles.getAttribute('data-sort');
                    if(sortTilesType == 'desc'){
                        sortTilesType = 'asc';
                    }else{
                        sortTilesType = 'desc';
                    }
                }
            }
            if(activeAnchorSelector.length != 0){
                activeAnchorSelector.forEach(function(activeAnchors){
                    dataTax = activeAnchors.getAttribute('data-tax');
                    dataSlug = activeAnchors.getAttribute('data-slug');
                })
            }else{
                dataTax = '';
                dataSlug = '';
            }

            if(activeAnchorSelector.length != 0){
                // Check if the dataTax key already exists in tilesCatObj
                if (tilesCatObj.hasOwnProperty(dataTax)) {
                    // If yes, check if dataSlug already exists in the array
                    if (!tilesCatObj[dataTax].includes(dataSlug)) {
                        // If not, append dataSlug to the array
                        tilesCatObj[dataTax].push(dataSlug);
                    }
                } else {
                    // If not, create a new key with an array containing dataSlug
                    tilesCatObj[dataTax] = [dataSlug];
                }
            }

            if(!isEmpty(tilesCatObj)){
                filtertilesObjects = JSON.stringify(tilesCatObj);
            }else{
                filtertilesObjects = '';
            }
            filterTiles(pageNo,sortTilesType,searchValue,filtertilesObjects);
            let scrollPosition = tileListingWrap.offsetTop;
            if(window.innerWidth < 992){
                window.scroll({
                    top: scrollPosition - 100,
                    behavior: 'smooth'
                });
            }else{
                window.scroll({
                    top: scrollPosition - 500,
                    behavior: 'smooth'
                });
            }   
        });
        }
    }

    if(searchField){
        searchField.addEventListener("keyup",debounce(function(e){
            if(e.key != "Enter"){
                const activeAnchorSelector = document.querySelector('.tiles-search-info-wrap .accordion-body ul li a.active');
                dataTax = '';
                dataSlug = '';
                if(activeAnchorSelector != null){
                    dataTax = activeAnchorSelector.getAttribute('data-tax');
                    dataSlug = activeAnchorSelector.getAttribute('data-slug');
                }
                if(!isEmpty(tilesCatObj)){
                    filtertilesObjects = JSON.stringify(tilesCatObj);
                }else{
                    filtertilesObjects = '';
                }
                let searchValue = this.value;
                filterTiles(1,'',searchValue,filtertilesObjects);
                if(window.innerWidth < 992){
                    let scrollPosition = tileListingWrap.offsetTop;
                    window.scroll({
                        top: scrollPosition - 100,
                        behavior: 'smooth'
                    });
                }
            }
        },1500));
    
        searchField.addEventListener("keypress",function(e){
            if(e.key == 'Enter'){
                e.preventDefault();
                const activeAnchorSelector = document.querySelector('.tiles-search-info-wrap .accordion-body ul li a.active');
                dataTax = '';
                dataSlug = '';
                if(activeAnchorSelector != null){
                    dataTax = activeAnchorSelector.getAttribute('data-tax');
                    dataSlug = activeAnchorSelector.getAttribute('data-slug');
                }
                if(!isEmpty(tilesCatObj)){
                    filtertilesObjects = JSON.stringify(tilesCatObj);
                }else{
                    filtertilesObjects = '';
                }
                let searchValue = this.value;
                filterTiles(1,'',searchValue,filtertilesObjects);
                if(window.innerWidth < 992){
                    let scrollPosition = tileListingWrap.offsetTop;
                    window.scroll({
                        top: scrollPosition - 100,
                        behavior: 'smooth'
                    });
                }
            }
        });
    }

    //On click of image tiles
    const imageTilesSelect = document.querySelectorAll('#tilestyles img');

    //For text inside the image tiles
    const imageTilesTextSelect = document.querySelectorAll('#tilestylestext div');

    imageTilesSelect.forEach(function(item){
        item.addEventListener('click',function(e){
            //Remove the active class on other img elements
            imageTilesSelect.forEach(el=>{
                el.classList.remove('active');
            });

            this.classList.add('active');
            dataTax = this.getAttribute('data-tax');
            dataSlug = this.getAttribute('data-slug');
            //Adding the active class on anchor elements if data-tax attribute of img matches with the anchor tags
            accordionAnchor.forEach(function(anchorElement){
                // anchorElement.classList.remove('active');
                if(dataSlug == anchorElement.getAttribute('data-slug')){
                    anchorElement.classList.add('active');
                     // Check if the dataTax key already exists in testObj
                    if (tilesCatObj.hasOwnProperty(dataTax)) {
                        // If yes, check if dataSlug already exists in the array
                        if (!tilesCatObj[dataTax].includes(dataSlug)) {
                            // If not, append dataSlug to the array
                            tilesCatObj[dataTax].push(dataSlug);
                        }
                    } else {
                        // If not, create a new key with an array containing dataSlug
                        tilesCatObj[dataTax] = [dataSlug];
                    }
                }
            });

            filtertilesObjects = JSON.stringify(tilesCatObj);
            filterTiles(1,'','',filtertilesObjects);
            if(window.innerWidth < 992){
                let scrollPosition = tileListingWrap.offsetTop;
                window.scroll({
                    top: scrollPosition - 100,
                    behavior: 'smooth'
                });
            }
        });
    })

    

    imageTilesTextSelect.forEach(function(item){
        item.addEventListener('click',function(e){
            //Remove the active class on other img elements
            imageTilesTextSelect.forEach(el=>{
                el.classList.remove('active');
            });

            this.classList.add('active');
            dataTax = this.getAttribute('data-tax');
            dataSlug = this.getAttribute('data-slug');
            //Adding the active class on anchor elements if data-tax attribute of img matches with the anchor tags
            accordionAnchor.forEach(function(anchorElement){
                // anchorElement.classList.remove('active');
                if(dataSlug == anchorElement.getAttribute('data-slug')){
                    anchorElement.classList.add('active');
                     // Check if the dataTax key already exists in testObj
                    if (tilesCatObj.hasOwnProperty(dataTax)) {
                        // If yes, check if dataSlug already exists in the array
                        if (!tilesCatObj[dataTax].includes(dataSlug)) {
                            // If not, append dataSlug to the array
                            tilesCatObj[dataTax].push(dataSlug);
                        }
                    } else {
                        // If not, create a new key with an array containing dataSlug
                        tilesCatObj[dataTax] = [dataSlug];
                    }
                }
            });
            filtertilesObjects = JSON.stringify(tilesCatObj);
            filterTiles(1,'','',filtertilesObjects);
            if(window.innerWidth < 992){
                let scrollPosition = tileListingWrap.offsetTop;
                window.scroll({
                    top: scrollPosition - 100,
                    behavior: 'smooth'
                });
            }
        });
    })

    //Sort A-Z/Z-A
    const tilesSort = document.querySelector('.tiles-search-info-wrap .tiles-sort');
    if(tilesSort){
        tilesSort.addEventListener('click',function(){
            let sortType = this.getAttribute('data-sort');
            const activeAnchorSelector = document.querySelector('.tiles-search-info-wrap .accordion-body ul li a.active');
            dataTax = '';
            dataSlug = '';
            if(activeAnchorSelector != null){
                dataTax = activeAnchorSelector.getAttribute('data-tax');
                dataSlug = activeAnchorSelector.getAttribute('data-slug');
            }
            if(!isEmpty(tilesCatObj)){
                filtertilesObjects = JSON.stringify(tilesCatObj);
            }else{
                filtertilesObjects = '';
                // Check if the dataTax key already exists in tilesCatObj
                if (tilesCatObj.hasOwnProperty(dataTax)) {
                    // If yes, check if dataSlug already exists in the array
                    if (!tilesCatObj[dataTax].includes(dataSlug)) {
                        // If not, append dataSlug to the array
                        tilesCatObj[dataTax].push(dataSlug);
                    }
                } else {
                    // If not, create a new key with an array containing dataSlug
                    tilesCatObj[dataTax] = [dataSlug];
                }
                    
                filtertilesObjects = JSON.stringify(tilesCatObj);
            }
            this.classList.add('active');
            if(sortType == 'asc'){
                this.setAttribute('data-sort','desc');
                this.innerHTML = 'Sort by Z-A';
            } else if(sortType == 'desc'){
                this.setAttribute('data-sort','asc');
                this.innerHTML = 'Sort by A-Z';
            }
            let searchFieldValue = searchField.value;
            filterTiles(1,sortType,searchFieldValue,filtertilesObjects);
        });
    }
    
    //Debounce function
    function debounce(callback, delay) {
        let timeout;
        return function () {
            let args = arguments
            clearTimeout(timeout)
            timeout = setTimeout(function () {
                callback.apply(this, args)
            }.bind(this), delay)
        }
    }

    //Function to check empty object
    function isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }

    // Filter product function
    function filterTiles(page = 1,sortType='',searchValue ='',filtertilesObjects = '') {
        if(tileListingWrap){
            tileListingWrap.innerHTML += '<div id="loading" class="show"><div class="loader"></div></div>';
        }
        let filterData = "";
        if(sortType == '' && sortTiles){
            sortTiles.classList.remove('active');
            sortTiles.setAttribute('data-sort','asc');
            sortTiles.innerHTML = 'Sort by A-Z';
        }

        filterData +="&sortType=" + sortType;
        filterData +="&searchValue=" + searchValue;
        filterData +="&filtertilesObject=" + filtertilesObjects;
        // Page data to send in request
        let pageData = "&pageNo=" + page;
        let pageUrlValue = document.getElementById('page-url').value;
        pageUrl = "&pageurl=" + pageUrlValue;

        // Ajax request
        let request = new XMLHttpRequest();
        request.open("POST", metz_ajax_callback_data.ajax_url, true);
        request.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=UTF-8"
        );
        
        request.onreadystatechange = () => {
            if (request.readyState === 4) {
                const loadMoreGif = document.querySelector("#loading");
                if(loadMoreGif){
                    loadMoreGif.remove();
                }
                const responseData = JSON.parse(request.response);
                if (responseData.data.output === 'no-items' && totalTiles) {
                    responseHtml = '<span class="no-result">No Results Found</span>';
                    totalTiles.innerHTML = "0 Product";
                }
                else {
                    if(clearFilter){
                        if(clearFilter.classList.contains('spinning')){
                            clearFilter.classList.remove('spinning');
                        }
                    }
                    responseHtml = responseData.data.output;
                    let foundPost = responseData.data.foundPost;
                    if(totalTiles){
                        totalTiles.innerHTML = foundPost < 2 ? foundPost + " Product" : foundPost >= 2 ? foundPost + " Products" : foundPost + " Product"; 
                    }

                }
                if(tileListingWrap){
                    tileListingWrap.innerHTML = responseHtml;
                }
                pagination();
            }
        };
        request.send(
        "action=tileslistings&nonce=" +
            metz_ajax_callback_data.ajax_nonce +
            filterData+
            pageData +
            pageUrl
        );
    }
}
})();